var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "columns is-gapless" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field is-horizontal" }, [
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field has-addons" }, [
                  _c(
                    "div",
                    { staticClass: "control has-icons-left has-icons-right" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter.query,
                            expression: "filter.query",
                          },
                        ],
                        staticClass: "input",
                        attrs: {
                          type: "text",
                          placeholder: "Start typing to filter",
                        },
                        domProps: { value: _vm.filter.query },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.filter, "query", $event.target.value)
                            },
                            _vm.search,
                          ],
                        },
                      }),
                      _vm._m(0),
                    ]
                  ),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary is-outlined tooltip",
                        attrs: { "data-tooltip": "Reset search" },
                        on: {
                          click: function ($event) {
                            return _vm.reset()
                          },
                        },
                      },
                      [_vm._m(1)]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm.showScrollToAdd
          ? _c(
              "div",
              {
                staticClass: "column is-narrow",
                staticStyle: { display: "flex", "align-items": "center" },
              },
              [
                _c("div", { staticClass: "field-body is-pulled-right" }, [
                  _c("div", { staticClass: "field is-narrow" }, [
                    _c("input", {
                      staticClass: "is-checkradio",
                      attrs: {
                        id: "labourScroll",
                        type: "checkbox",
                        name: "labourScroll",
                      },
                      domProps: { checked: _vm.$userInfo.scrollItemPart },
                      on: { change: _vm.$setScrollItemPart },
                    }),
                    _c("label", { attrs: { for: "labourScroll" } }, [
                      _vm._v("Scroll on add"),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "table-container-avaialble-butterfly-items" },
      [
        _c(
          "bulma-table",
          {
            staticClass: "table is-striped is-narrow is-fullwidth",
            attrs: {
              columns: _vm.columns,
              "has-sticky-header": true,
              "page-index": _vm.filter.pageIndex,
              "page-size": _vm.filter.pageSize,
              "total-rows": _vm.totalRows,
              "is-loading": _vm.isTableLoading,
              "sort-column": _vm.filter.sortColumn,
              "sort-order": _vm.filter.sortOrder,
            },
            on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
          },
          [
            _vm._l(_vm.availableItems, function (item, index) {
              return _c(
                "tr",
                {
                  key: index,
                  on: {
                    dblclick: function ($event) {
                      return _vm.addNewItem(item, index)
                    },
                  },
                },
                [
                  _c("td", [_vm._v(_vm._s(item.itemNo))]),
                  _c("td", [_vm._v(_vm._s(item.description))]),
                  _c("td", { staticClass: "has-text-centered" }, [
                    _vm._v(_vm._s(item.quantity)),
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: "has-text-right mr-2",
                      on: {
                        click: function ($event) {
                          return _vm.addNewItem(item, index)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "butterfly-item-values is-flex is-justify-content-center px-2 mr-2",
                          class: {
                            " has-text-weight-bold is-selected":
                              _vm.getExistingItem(
                                item,
                                _vm.itemCategoryTypes.PART
                              ),
                          },
                        },
                        [_vm._v(" + ")]
                      ),
                    ]
                  ),
                ]
              )
            }),
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  { staticClass: "content has-text-grey has-text-centered" },
                  [
                    _c("span", { attrs: { icon: "icon is-large" } }, [
                      _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                    ]),
                    _c("p", [_vm._v("Nothing")]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      [
        _vm.isButterflyModalActive
          ? _c(
              "butterfly-modal",
              {
                attrs: { active: _vm.isButterflyModalActive },
                on: {
                  "update:active": function ($event) {
                    _vm.isButterflyModalActive = $event
                  },
                  filterButterfly: _vm.butterflySearch,
                  reset: _vm.reset,
                  done: _vm.filterButterly,
                  cancel: _vm.cancel,
                },
                model: {
                  value: _vm.selectedButterflyCodes,
                  callback: function ($$v) {
                    _vm.selectedButterflyCodes = $$v
                  },
                  expression: "selectedButterflyCodes",
                },
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "text-content" }, slot: "text-content" },
                  [
                    _vm.isButterflyModalActive
                      ? _c("butterfly", {
                          model: {
                            value: _vm.selectedButterflyCodes,
                            callback: function ($$v) {
                              _vm.selectedButterflyCodes = $$v
                            },
                            expression: "selectedButterflyCodes",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }